import React, { useEffect, useState, useCallback } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import AddUpdatePurchase from "./addUpdatePurchase";
import Table from "../../common/Table/table";
import {
  addPurchaseSlice,
  updatePurchaseSlice,
  getAllPurchaseSlice,
  getPurchaseByIdSlice,
  resetAddPurchaseMessage,
  resetUpdatePurchaseMessage,
} from "../../../store/slices/purchaseSlice";
import ViewPurchaseDetails from "./viewPurchaseDetails";

const Purchase = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [showGlobalViewModal, setShowGlobalViewModal] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);
  const [reportFromData, setReportFromData] = useState({
    fromDate: "",
    toDate: "",
  });
  const [viewModal, setViewModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const dispatch = useDispatch();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
 const clinicId =
    clinicInfo?.[0]?._id ||
    clinicInfo?.[0]?.clinicId ||
    null;

  const initialState = {
    supplier: "",
    supplierName: "",
    invoiceId: "",
    invoiceDate: "",
    subTotal: "",
    taxbleAmount: "",
    totalAmount: "",
    items: [],
  };
  const [purchaseFormData, setPurchaseFormData] = useState(initialState);
  const [inputError, setInputError] = useState({
    supplier: false,
    invoiceId: false,
    invoiceDate: false,
  });

  const [userInput, setUserInput] = useState({
    name: false,
    email: false,
    phone: false,
  });

  const handleEdit = async (purchase) => {
    try {
      const response = await dispatch(
        getPurchaseByIdSlice({ purchaseId: purchase?.id, token })
      );

      if (response?.payload) {
        const purchaseData = response?.payload?.result?.list;
        setPurchaseFormData({
          purchaseId: purchaseData?._id,
          supplier: purchaseData?.supplier?._id,
          supplierName: purchaseData?.supplier?.name,
          invoiceId: purchaseData?.invoiceId,
          invoiceDate: purchaseData?.invoiceDate?.split("T")[0],
          subTotal: purchaseData?.subTotal,
          items: purchaseData?.items || [],
        });
        handleModal("edit", purchaseData);
      }
    } catch (error) {
      console.error("Failed to get Purchase: Please Try Later..", error);
    }
  };
  const {
    purchases,
    purchaseInfo,
    createPurchaseSuccessMessage,
    createPurchaseErrorMessage,
    updatePurchaseSuccessMessage,
    updatePurchaseErrorMessage,
    searchPurchaseErrorMessage,
    currentPage,
    totalPages,
    totalCount,
    isLoading,
  } = useSelector((state) => state.purchase);
  useEffect(() => {
    showTostifyMessageAndReset(
      createPurchaseSuccessMessage,
      showToastifySuccess,
      resetAddPurchaseMessage
    );
    showTostifyMessageAndReset(
      createPurchaseErrorMessage,
      showToastifyError,
      resetAddPurchaseMessage
    );
    showTostifyMessageAndReset(
      updatePurchaseSuccessMessage,
      showToastifySuccess,
      resetUpdatePurchaseMessage
    );
    showTostifyMessageAndReset(
      updatePurchaseErrorMessage,
      showToastifyError,
      resetUpdatePurchaseMessage
    );
  }, [
    createPurchaseSuccessMessage,
    createPurchaseErrorMessage,
    showTostifyMessageAndReset,
    updatePurchaseSuccessMessage,
    updatePurchaseErrorMessage,
  ]);


  const fetchPurchase = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (clinicId && token) {
        dispatch(
          getAllPurchaseSlice({
            clinicId,
            token,
            currentPage: page,
            limit: lim,
            search: search || undefined,
            fromDate: reportFromData.fromDate || undefined,
            toDate: reportFromData.toDate || undefined,
          })
        );
      }
    },
    [
      clinicInfo,
      token,
      dispatch,
      searchValue,
      pageLimit,
      reportFromData.fromDate,
      reportFromData.toDate,
    ]
  );

  useEffect(() => {
    fetchPurchase();
  }, [fetchPurchase, showModal, showGlobalViewModal]);

  const handlePageChange = (page) => {
    fetchPurchase(page, pageLimit, searchValue);
  };
  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchPurchase(1, newLimit, searchValue);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPurchaseFormData((prev) => ({
      ...prev,
      [name]: value,
      items: prev.items || [],
    }));
  };

  const handleSelectChange = (selectedOption, name) => {
    setPurchaseFormData((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
      [`${name}Name`]: selectedOption?.label,
      items: prev.items || [],
    }));
  };

  const handleModal = (action, purchase = null) => {
    if (action === "edit" && purchase) {
      setPurchaseFormData({
        purchaseId: purchase?._id,
        supplier: purchase?.supplier?._id,
        supplierName: purchase?.supplier?.name,
        invoiceId: purchase?.invoiceId,
        invoiceDate: purchase?.invoiceDate?.split("T")[0],
        subTotal: purchase?.subTotal,
        items: purchase?.items || [],
      });
    } else if (action === "create") {
      setPurchaseFormData(initialState);
    }
    setShowModal(true);
    setModalAction(action);
  };

  const handleAddUpdate = async (items) => {
    const subTotal = items.reduce(
      (sum, item) => sum + Number(item?.totalAmount || 0),
      0
    );
    const purchasePayload = {
      ...purchaseFormData,
      items,
      subTotal,
      clinicId,
      token,
    };
    let response;
    // Dispatch or API call goes here
    if (modalAction === "edit" && purchasePayload?.purchaseId) {
      response = await dispatch(updatePurchaseSlice(purchasePayload));
    } else {
      response = await dispatch(addPurchaseSlice(purchasePayload));
    }
    if (response?.payload?.success) {
      await dispatch(
        getAllPurchaseSlice({ clinicId, token })
      );
      setPurchaseFormData(initialState);
      setShowModal(false);
    }
  };
  const handleSearch = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchValue(value);
      fetchPurchase(1, pageLimit, value);
    },
    [fetchPurchase, pageLimit]
  );

  const tableHead = [
    { title: "Invoice No.", key: "invoiceId" },
    { title: "Supplier", key: "supplier" },
    { title: "Invoice Date", key: "invoiceDate" },
    { title: "Entry Date", key: "entryDate" },
    { title: "Amount", key: "amount" },
  ];

  const handleShowGlobalViewModal = async (data) => {
    const res = await dispatch(
      getPurchaseByIdSlice({ purchaseId: data?.id, token })
    );
    const purchaseData = res?.payload?.result?.list;
    setPurchaseFormData({
      purchaseId: purchaseData?._id,
      supplier: purchaseData?.supplier?._id,
      supplierName: purchaseData?.supplier?.name,
      invoiceId: purchaseData?.invoiceId,
      invoiceDate: purchaseData?.invoiceDate?.split("T")[0],
      subTotal: purchaseData?.subTotal,
      items: purchaseData?.items || [],
    });
    setViewModal(true);
  };

  const handleFilter = async () => {
    await dispatch(
      getAllPurchaseSlice({
        clinicId,
        fromDate: reportFromData.fromDate,
        toDate: reportFromData.toDate,
        token,
        currentPage: 1,
        limit: pageLimit,
        search: searchValue || undefined,
      })
    );
  };

  const handleClear = useCallback(async () => {
    setReportFromData({ fromDate: "", toDate: "" });
    setSearchValue("");
    await dispatch(
      getAllPurchaseSlice({
        clinicId,
        token,
        currentPage: 1,
        limit: pageLimit,
      })
    );
  }, [dispatch, clinicInfo, token, pageLimit]);

  return (
    <>
      <div className="row">
        <div className="col-md-2">
          <div className="form-group form-focus focused">
            <label className="focus-label">From</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.fromDate}
                onChange={(e) =>
                  setReportFromData({
                    ...reportFromData,
                    fromDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="form-group form-focus focused">
            <label className="focus-label">To</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.toDate}
                onChange={(e) =>
                  setReportFromData({
                    ...reportFromData,
                    toDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>

        <div className="col-md-3 mt-2">
          <button className="btn btn-primary mt-3" onClick={handleFilter}>
            Filter
          </button>
          <button className="btn btn-danger mt-3 ms-3" onClick={handleClear}>
            Clear
          </button>
        </div>
      </div>
      <>
        <div className="container mt-4">
          <Table
            tableHead={tableHead}
            tableBody={
              purchases &&
              purchases?.map((item) => ({
                id: item?._id,
                invoiceId: item?.invoiceId || "N/A",
                supplier: item?.supplier?.name || "N/A",
                invoiceDate: item?.invoiceDate
                  ? new Date(item.invoiceDate)
                    .toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })
                    .replace(/\//g, "-")
                  : "N/A",
                entryDate: item?.createdDt
                  ? new Date(item.createdDt)
                    .toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })
                    .replace(/\//g, "-")
                  : "N/A",
                amount: item?.subTotal || "N/A",
                status: item?.status || "N/A",
              }))
            }
            handleAddBtn={true}
            handleSearchOption={true}
            searchValue={searchValue}
            handleSearch={handleSearch}
            errorMessage={searchPurchaseErrorMessage}
            handleShowGlobalViewModal={handleShowGlobalViewModal}
            handleEdit={handleEdit}
            addModal={() => handleModal("create")}
           hideStatusTab={false}
            handleShare={false}
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            limit={pageLimit}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
            showPagination={true}
            showLimitDropdown={true}
            isLoading={isLoading}
          />
          <AddUpdatePurchase
            showModal={showModal}
            setShowModal={setShowModal}
            handleAddUpdate={handleAddUpdate}
            purchaseFormData={purchaseFormData}
            setPurchaseFormData={setPurchaseFormData}
            handleChange={handleChange}
            handleSelectChange={handleSelectChange}
            modalAction={modalAction}
            setInputError={setInputError}
            userInput={userInput}
          />
          <ViewPurchaseDetails
            show={viewModal}
            onHide={() => setViewModal(false)}
            purchaseData={purchaseFormData}
          />
          <Modal
            centered
            show={deleteModal}
            onHide={() => setDeleteModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Are You Sure Want to Delete it?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              After deleting, you won't be able to recover the data
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                onClick={() => setDeleteModal(false)}
                className="p-2"
              >
                Cancel
              </Button>
              <Button variant="danger" className="p-2">
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </>
    </>
  );
};

export default Purchase;
